import useMaps from '../../hooks/location/useMaps';
import useCompanyLocation from '../../hooks/location/useCompanyLocation';
import { Moment } from 'moment';
import AddressHelpers from '../../services/helpers/AddressHelpers';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import { CompanyDetailsInterface } from '../../services/exports/Interfaces';

interface Props {
  datetime?: null | string | Moment;
  showPhoneNumber?: boolean;
  shouldOpenMap?: boolean;
  className?: string;
  company?: CompanyDetailsInterface;
}

export default function CompanyDescription(props: Props) {
  const { company: defaultCompany } = useSelector((state: StoreInterface) => state.initialData);
  const company = props?.company ?? defaultCompany;

  const { datetime, showPhoneNumber, shouldOpenMap, className } = props;

  const { openMap } = useMaps({
    company,
  });
  const location = useCompanyLocation({
    datetime,
    company,
  });

  return (
    <div className={className}>
      <p className="text-sm">{company?.name}</p>
      <div>
        <button onClick={() => (shouldOpenMap ? openMap() : null)}>
          <p className="text-brand-primary mt-xs text-sm hover:underline">
            {AddressHelpers.format({
              street_name: location?.address,
              city: location?.city,
              zip_code: location.zip_code,
              format: company?.region?.address_format,
            })}
          </p>
        </button>
      </div>
      {showPhoneNumber && company?.phone_number && (
        <div className="mt-xs">
          <a href={`tel:${company?.phone_number}`} className="inline text-blue-100 text-sm">
            <p>Tel: {company?.phone_number}</p>
          </a>
        </div>
      )}
    </div>
  );
}
